import { render, staticRenderFns } from "./ProductDepartmentForm.vue?vue&type=template&id=236157f4&"
import script from "./ProductDepartmentForm.vue?vue&type=script&lang=js&"
export * from "./ProductDepartmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports